import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';

import styles from '../styles';

import type { DispatchProp } from 'react-redux';

interface IProps extends DispatchProp<any> {
  onChange?: any;
  onApply?: any;
  filter: any;
  active: boolean;
  classes?: any;
  count: any;
  disabled?: boolean;
}

interface IStates {}

class Tags extends React.Component<IProps, IStates> {
  cleanFilter = () => {
    const onlyPeriod = this.props.filter['period'];

    (async () => {
      try {
        this.props.dispatch({ type: 'REPLACE_FILTER_TAG', newFilter: { period: onlyPeriod } });
        if (this.props.onChange) {
          this.props.onChange();
        }
        if (this.props.onApply) {
          this.props.onApply();
        }
      } catch (error) {}
    })();
  };
  onRemoveTag = (prop: any, obj: any) => {
    let newFilter = this.props.filter;
    let isApplied = false;
    if (Array.isArray(newFilter[prop])) {
      let it = newFilter[prop].find((item: any) => item.label === obj.value);
      isApplied = it.applied;
      newFilter[prop] = newFilter[prop].filter((item: any) => item.label !== obj.value);
    } else {
      isApplied = newFilter[prop] && newFilter[prop].applied ? true : false;
      delete newFilter[prop];
    }
    (async () => {
      try {
        await this.props.dispatch({ type: 'REPLACE_FILTER_TAG', newFilter });
        if (this.props.onChange) {
          this.props.onChange();
        }
        if (isApplied && this.props.onApply) {
          this.props.onApply();
        }
      } catch (error) {}
    })();
  };
  onApply = () => {
    (async () => {
      try {
        await this.props.dispatch({ type: 'APPLY_FILTER_TAG' });
        if (this.props.onApply) {
          this.props.onApply();
        }
      } catch (error) {}
    })();
  };

  render() {
    const { classes, filter, count, active, disabled } = this.props;
    const getLabels = () => {
      let labels: any = [];
      if (filter) {
        for (let prop in filter) {
          if (Array.isArray(filter[prop])) {
            labels = labels.concat(
              filter[prop].map((item: any) => {
                if (item.label) {
                  return {
                    label: prop,
                    value: item.label,
                    prop,
                    nonRemovable: item.nonRemovable,
                    applied: item.applied,
                  };
                }
                return { label: prop, value: item, prop, nonRemovable: item.nonRemovable, applied: item.applied };
              })
            );
          } else {
            if (prop !== 'count' && prop !== 'active' && prop !== 'modified') {
              if (prop === 'period') {
                const currentPeriod = filter[prop];
                if (currentPeriod) {
                  if (currentPeriod.type) {
                    labels.unshift({
                      label: `Período de ${currentPeriod.type.label}`,
                      value: `de ${moment(currentPeriod.startDate).format('DD/MM/YYYY')} até ${moment(currentPeriod.endDate).format('DD/MM/YYYY')}`,
                      prop,
                      //nonRemovable: currentPeriod.nonRemovable,
                      nonRemovable: true,
                      applied: currentPeriod.applied,
                    });
                  } else {
                    labels.unshift({
                      label: 'Período',
                      value: `de ${moment(currentPeriod.startDate).format('DD/MM/YYYY')} até ${moment(currentPeriod.endDate).format('DD/MM/YYYY')}`,
                      prop,
                      nonRemovable: true,
                      //nonRemovable: currentPeriod.nonRemovable,
                      applied: currentPeriod.applied,
                    });
                  }
                }
              } else {
                if (filter[prop].label) {
                  labels.push({
                    label: prop,
                    value: filter[prop].label,
                    prop,
                    nonRemovable: filter[prop].nonRemovable,
                    applied: filter[prop].applied,
                  });
                } else {
                  labels.push({
                    label: prop,
                    value: filter[prop],
                    prop,
                    nonRemovable: filter[prop].nonRemovable,
                    applied: filter[prop].applied,
                  });
                }
              }
            }
          }
        }
      }
      return labels && Array.isArray(labels) && labels.length
        ? labels.map((item: any) => (
            <Chip
              key={item.value}
              label={`${item.label}: ${item.value}`}
              onDelete={!item.nonRemovable && !disabled ? () => this.onRemoveTag(item.prop, item) : undefined}
              classes={item.applied ? { root: classes.chipResultRootActive } : { root: classes.chipResultRoot }}
            />
          ))
        : null;
    };
    return (
      <div style={{ paddingTop: 0 }}>
        <Grid container>
          <Grid xs={12} sm={12} md={12} item spacing={4}>
            <div className={classes.filterField}>
              <div style={{ width: '100%' }}>
                <p style={{ width: '100%', textAlign: 'center' }} className={count > 0 ? 'hide' : 'show'}>
                  Selecione suas opções de filtros acima
                </p>
                {getLabels()}
              </div>
              <div className={`${classes.fieldClean}${count > 0 ? ' ' : ' hide'}`}>
                <Button style={{ float: 'right' }} disabled={disabled} onClick={this.cleanFilter}>
                  x Limpar filtros
                </Button>
              </div>
              {this.props.onApply && (
                <div className={`${classes.fieldApply}${count > 0 ? ' ' : ' hide'}`}>
                  <Button disabled={count === active || disabled} style={{ float: 'right' }} onClick={this.onApply}>
                    <Icon>done</Icon>
                    Aplicar
                  </Button>
                </div>
              )}
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    filter: state.components.FilterTag.filter,
    count: state.components.FilterTag.filter.count,
    active: state.components.FilterTag.filter.active,
  };
}

export default connect(mapStateToProps)(styles(Tags));
